import { users } from "../endpoints/users.endpoints";
import $axios from "../http/accessor";

const UsersService = {
  getALlUsers: (page: number, count: number, search?: string) => {
    return $axios.get(users.all_users, {
      params: {
        page,
        count,
        search,
      },
    });
  },

  getOneUser: (id: number) => {
    return $axios.get(users.get_one_user(id));
  },
  deleteUser: (id: number) => {
    return $axios.delete(users.get_one_user(id));
  },
  getStatistics: () => {
    return $axios.get(users.statistics);
  },
  updateUserRole: (id: number, role: string) => {
    return $axios.put(users.update_user_role, { id, role });
  },
};

export default UsersService;
